import React from "react";

import { PageFrame } from "components/auth/PageFrame";

const PAGE_DATA = {
  title: "Link enviado!",
  subtitle: "Confira a sua caixa de e-mail.",
  buttonText: "Voltar",
  to: "/",
};

export const LinkSent = () => {
  const { title, subtitle, buttonText, to } = PAGE_DATA;
  return (
    <PageFrame
      title={title}
      subtitle={subtitle}
      buttonAnchor={{ text: buttonText, to: to }}
    />
  );
};
